<template>
  <div class="page-container">
    <el-row class="tac">
      <el-col :span="4">
        <h5>영업노트</h5>
        <el-menu>
          <li class="search-panel">
            <el-input size="mini" v-model="search" placeholder="이름으로 검색" @keyup.enter.native="searchHandler" />
          </li>
        </el-menu>
      </el-col>
      <el-col :span="20">
        <div class="page-container">
          <div class="timeline-container">
            <el-timeline>
              <el-timeline-item 
                v-for="item in list"
                :key="item.pk"
                :timestamp="item.create_time | moment('YYYY-MM-DD')" 
                placement="top">
                <el-card>
                  <p class="memo-context">{{item.memo}}</p>
                  <div class="memo-meta">
                    <el-tag size="small" 
                      @click="$router.push({
                        name: 'management-detail', 
                        params: {company_pk: item.company.pk}
                      })">{{item.company.company_name || '개인사용자'}}
                    </el-tag>
                    &nbsp;
                    <el-tag size="small">{{item.manager}}</el-tag>
                    &nbsp;
                    <el-tag size="small">{{item.type}}</el-tag>
                  </div>
                </el-card>
              </el-timeline-item>
            </el-timeline>

            <el-button type="primary" :loading="loading" @click="moreMemo" style="width:100%">더보기</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    async getMemo () {
      this.loading = true
      let query = {
        order_by: [{ field: 'create_time', direction: 'desc' }]
      }
      if (this.search) query.filters = [{ name: 'manager', op: 'eq', val: this.search }]
      let params = {
        results_per_page: this.pagination.limit,
        page: this.pagination.page,
        q: JSON.stringify(query)
      }
      let {data} = await this.$http.get('memo', {params})
      this.pagination.total = data.total_pages
      this.list = this.list.concat(data.objects)
      this.loading = false
      return data
    },
    searchHandler () {
      if (this.search) this.$service.localdb.setItem('admin_name', this.search)
      this.list = []
      this.pagination.limit = 5
      this.pagination.page = 1
      this.pagination.total = 1
      
      this.getMemo()
    },
    moreMemo () {
      if (this.pagination.total <= this.pagination.page) {
        return this.$message.info('마지막 페이지입니다')
      }
      this.pagination.page += 1
      this.getMemo()
    }
  },
  async mounted () {
    let adminName = await this.$service.localdb.getItem('admin_name')
    if (adminName) this.search = adminName
    this.getMemo()
    return;
  },
  data () {
    return {
      loading: false,
      search: '',
      pagination: {
        limit: 5,
        page: 1,
        total: 1
      },
      list: []
    }
  }
}
</script>

<style lang="scss" scoped>
.search-panel {
  padding: 20px;
}
.timeline-container {
  background-color: white;
  padding: 50px;
  overflow: auto;
}
.memo-context {
  white-space: pre-wrap;
  font-size: 12px;
  color: #565656;
  line-height: 23px;
  padding: 0;
  margin: 0;
}

.memo-meta {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid #ebebeb;
  text-align: right;
}

</style>

